/**
 * 手机号码
 */
export const mobileReg = /^1[3-9]\d{9}$/;
